// extracted by mini-css-extract-plugin
module.exports = {"buttonLink":"k3AQD","buttonWrapper":"pUIGN","resendForm":"fUB7E","hidden":"G0fFb"};